import * as TypeAction from './actionTypes'
import { actionSincCRUD, actionSyncListObj } from 'scorpion-core';
import { salvaCustomForm, manterSincronizacaoCustomForms } from './api';

import { userUid } from '../../../firebase'

export const salvar = (customForm, retorno) => (dispatch) => {
    if (!customForm.users) {
        let users = {}
        users[userUid()] = true;
        customForm.users = users
    }

    actionSincCRUD(salvaCustomForm(customForm), TypeAction.SALVAR, dispatch, retorno)
}

export const listar = () => (dispatch) => {
    manterSincronizacaoCustomForms(actionSyncListObj(TypeAction.LISTAR, dispatch));
}



// WEBPACK FOOTER //
// ./src/routes/sistema/CriarCustomForm/actions.js